import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  QueryDefinition,
  QueryActionCreatorResult,
} from '@reduxjs/toolkit/query';

import { useGetPublicProfileBadgesQuery } from 'src/features/public-profile/components/badges-tab/badges.slice';
import { ApiResponse, BadgeItem, PaginatedResponse } from 'src/common/interfaces';
import { PublicProfileParams } from 'src/common/interfaces/public-profile';
import { RTKQueryTag } from 'src/common/constants';

type UseGetBadgesResponse = {
  badges: BadgeItem[] | undefined;
  isLoading: boolean;
  refetch: () => QueryActionCreatorResult<
    QueryDefinition<
      PublicProfileParams,
      BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
      RTKQueryTag,
      ApiResponse<PaginatedResponse<BadgeItem>>,
      'api'
    >
  >;
  totalBadges: number | undefined;
  totalPages: number | undefined;
};

export const useGetBadges = (userId: string, page: number, limit = 16): UseGetBadgesResponse => {
  const { data, isLoading, refetch } = useGetPublicProfileBadgesQuery({ user: userId, limit, page }, { skip: !userId });

  return {
    badges: data?.data?.docs,
    isLoading,
    refetch,
    totalBadges: data?.data?.totalDocs,
    totalPages: data?.data?.totalPages,
  };
};
